// extracted by mini-css-extract-plugin
export default {"cta":"GI-z","disabled":"HI-z"};